import { HttpMethod, defineHandler } from "@tsp/api";

import { AccrualModelUnitName, QuantityMapKey } from "@tsp-domains/accrual-models/enums";
import { AccrualModelId } from "@tsp-domains/accrual-models/types";
import { CurrencyId } from "@tsp-domains/money/enums";
import { PartyUuid } from "@tsp-domains/parties/types";
import { PropertyUuid } from "@tsp-domains/projects-portfolio/types";
import { WorkItemEntityType } from "@tsp-domains/work-items/enums";
import { WorkSubTypeUuid, WorkTypeId } from "@tsp-domains/work-types/types";

export type LoadSupplierActualWorkTypesRequestParams = {
  momentAt: number;
  propertyUuid: PropertyUuid;
  supplierUuids: Array<PartyUuid>;
  entityType: WorkItemEntityType;
  isActiveContracts?: boolean;
};

export type LoadSupplierActualWorkTypesResponseData = {
  workTypes: Array<{
    id: WorkTypeId;
    workSubTypes: Array<{
      uuid: WorkSubTypeUuid;
      accrualModel: {
        model_id: AccrualModelId;
        model_unit_name: AccrualModelUnitName;
        currencyId: CurrencyId;
        quantityFields: Array<QuantityMapKey>;
        isLegacy: boolean;
      };
    }>;
  }>;
};

export const loadSupplierActualWorkTypes = defineHandler<
  LoadSupplierActualWorkTypesRequestParams,
  LoadSupplierActualWorkTypesResponseData
>({
  path: "/getActualWorkTypes",
  method: HttpMethod.POST,
});

export const supplierWorkTypesApi = {
  loadSupplierActualWorkTypes,
};
